module.exports = __webpack_public_path__ + "static/media/filters.02c6f22e.svg";